export const FETCH_ALL_ACTIVITY_REQUEST = 'FETCH_ALL_ACTIVITY_REQUEST';
export const FETCH_ALL_ACTIVITY_SUCCESS = 'FETCH_ALL_ACTIVITY_SUCCESS';
export const FETCH_ALL_ACTIVITY_FAILURE = 'FETCH_ALL_ACTIVITY_FAILURE';
export const CLEAR_ALL_ACTIVITY         = 'CLEAR_ALL_ACTIVITY';
